// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Button,
    Col,
    Row
} from '@sketchpixy/rubix'

class DBQ extends Component {
    constructor(props) {
        super(props)
        let currentDbq = this.props.location && this.props.location.currentDbq ? this.props.location.currentDbq : JSON.parse(sessionStorage.getItem('currentDbq'));
        let patient = this.props.location && this.props.location.patient ? this.props.location.patient: JSON.parse(sessionStorage.getItem("patient"));
        let questionState = this.props.location && this.props.location.questionState ? this.props.location.questionState : JSON.parse(sessionStorage.getItem("questionState"));

        props.location.file && sessionStorage.setItem('fileUrl', props.location.file)
        this.state = {
            patient: patient,
            currentDbq: currentDbq,
            questions: questionState,
            file: props.location.file && props.location.file.length>0 ? props.location.file : sessionStorage.getItem('fileUrl'),
            fileUrl: null,
            isLoading: true,
            current:0
        }
    }

    actions = link => {
        const { history } = this.props
        history.push({pathname:link, currentDbq: this.state.currentDbq, patient: this.state.patient, questionState: this.state.questions, file: this.state.file})
    }

    goBack = link => {
        const { history } = this.props
        history.push({ pathname: link, currentDbq: this.state.currentDbq, patient: this.state.patient, questionState: this.state.questions})
    }

    goToDashboard = () => {
        const { history } = this.props
        history.push({pathname:'/admin/dashboard'})
    }

    fetchFile = async () => {
        try {
            const { location } = this.props;

            if (location.file) {
                const fileName = location.file.split('/').pop();

                let token = localStorage.getItem('login_token');
                let headers = {"Content-Type": "application/json"};
                headers["Authorization"] = `Bearer ${token}`

                const response = await fetch(`${process.env.API_URL}/file/${fileName}`, {
                    method: 'GET',
                    headers,
                });
            
                if (!response.ok) throw new Error("Failed to fetch PDF");
            
                const blob = await response.blob();
                const fileUrl = URL.createObjectURL(blob);
            
                this.setState({ fileUrl: fileUrl });
            }
        
        } catch (error) {
            console.error("PDF Fetch Error:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    componentDidMount() {
        this.fetchFile();
    }

    componentWillUnmount() {
        if (this.state.fileUrl) {
            URL.revokeObjectURL(this.state.fileUrl);
        }
    }

    render() {
        const { fileUrl, isLoading } = this.state;
        return (
            <div>
                {(fileUrl || isLoading) ? <div>
                    <Row className="height400">
                        <Col xs={12} smOffset={1} sm={10} className="text-center">
                            <h1 className="heading-main">
                                <strong>Review DBQ</strong>
                                <span className='pdf-warning-container'> 
                                    <span className='pdf-review-warning-text'>Modifying the PDF form directly will not save any changes you make. To ensure your responses are recorded, please use the 'Back' button below and edit your answers from there.</span>
                                </span>
                            </h1>
                            <div style={{marginTop:30}}>
                                <object width="100%" height="800" data={this.state.fileUrl ? this.state.fileUrl : ""} type="application/pdf">   </object>
                            </div>
                        </Col>
                    </Row>
                    <Row className="button-bottom" style={{ bottom: 0, marginBottom: 15 }}>
                        <Col xs={6} collapseLeft collapseRight className='text-right button-bottom'>
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="back-btn big-btn"
                                onClick={this.goBack.bind(this, "/admin/review")}
                            >Back<span className="backiconspan"><svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.48866 0L9.97699 1.7625L4.08699 8.75H16.9331V11.25H4.08699L9.97699 18.2375L8.48866 20L0.0442162 10L8.48866 0Z" fill="#797979"/>
                            </svg>
                            </span></Button>
                        </Col>
                        <Col xs={6} collapseLeft collapseRight
                            className='text-left button-bottom'>
                            <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="next-btn big-btn"
                                onClick={this.actions.bind(this, "/admin/sign")}
                            >Next<span className="nexticonspan"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z" fill="white"/>
                            </svg>
                            </span></Button>
                        </Col>
                    </Row>

                </div> :
                <div>
                    <Row style={{marginTop: 100}}>
                        <Col sm={2}></Col>
                        <Col sm={8}>
                            <div className="review-box"> 
                                <h2 style={{color: "#079EDA", fontWeight: 'bold', textAlign: 'center'}}>
                                    Thank you for completing the exam. Your responses have been saved. 
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 20}}>
                    <Col sm={4}></Col>
                        <Col>
                        <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="big-btn"
                                onClick={e => {this.goToDashboard()}}
                            >Return to Dashboard<span className="nexticonspan"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z" fill="white"/>
                            </svg>
                            </span></Button>
                        </Col>
                    </Row>
                </div>
                }

            </div>
        )
    }
}


const mapStateToProps =
    ({ fetching }) => ({
        fetching
    })

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DBQ)
